module.exports = "h1 {\r\n    color: #00579e;\r\n    font-size: 2em;\r\n}\r\n\r\ntable.list-table th, table.list-table td {\r\n    border-right: none;\r\n    border-left: none;\r\n    border-top: 1px solid #b9b9b9;\r\n    border-bottom: 1px solid #b9b9b9;\r\n    vertical-align: middle;\r\n    text-align: left;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app_manager/app_element/client-detail/mail-history/mail-history.component.css
// module id = ./src/app/app_manager/app_element/client-detail/mail-history/mail-history.component.css
// module chunks = main